import React from 'react'
import "./Footer.css"
import falcop from "../Assets/falcop.jpg"
import footer_bg from "../Assets/footer_bg.png"
import { FaDiscord, FaTwitter, FaYoutube, FaInstagram, FaTiktok, FaEnvelope, FaPhone, FaGlobe } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { SiOpensea } from 'react-icons/si'

export default function Footer() {
  return (
    <div className='footer_main_section'>
      <div className="footer_background"></div>
      <div className="container position-relative">
        {/* Main Footer Content */}
        <div className="footer_content">
          <div className="row g-4">
            {/* Brand Section */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="footer_brand">
                <div className='footer_logo_section'>
                  <div className="footer_logo_container">
                    <img src={falcop} alt="Falco P Logo" />
                  </div>
                  <h3 className='footer_brand_name'>Falco P</h3>
                </div>
                <p className='footer_description'>
                  You are not just buying a shoe. You are buying a piece of a dream. 
                  The Falco P - where athletic performance meets aerodynamic artistry.
                </p>
                <div className="footer_social_icons">
                  <a href="https://discord.gg/T5XsyYjR" target="_blank" rel="noopener noreferrer" className="social_icon_link">
                    <FaDiscord size={24} />
                  </a>
                  <a href="https://x.com/falcoswoop?s=11" target="_blank" rel="noopener noreferrer" className="social_icon_link">
                    <FaXTwitter size={24} />
                  </a>
                  <a href="https://youtube.com/@falcoswoop?si=zcqc0bhS7V-Qdd2n" target="_blank" rel="noopener noreferrer" className="social_icon_link">
                    <FaYoutube size={24} />
                  </a>
                  <a href="https://www.instagram.com/falcoswoop?igsh=NG1yOTE0ZHR5NGh3" target="_blank" rel="noopener noreferrer" className="social_icon_link">
                    <FaInstagram size={24} />
                  </a>
                  <a href="https://www.tiktok.com/@falco.p1?_t=ZN-8zh2w9qxTaY&_r=1" target="_blank" rel="noopener noreferrer" className="social_icon_link">
                    <FaTiktok size={24} />
                  </a>
                  <a href="https://opensea.io/collection/falco-p-sportswear-revolution-373261412" target="_blank" rel="noopener noreferrer" className="social_icon_link">
                    <SiOpensea size={24} />
                  </a>
                </div>
                <div className="footer_contact_info mt-3">
                  <p className="contact_item">
                    <FaEnvelope className="contact_icon" />
                    <strong>Email:</strong> <a href="mailto:Falcoswoop@gmail.com" className="contact_link">Falcoswoop@gmail.com</a>
                  </p>
                  <p className="contact_item">
                    <FaPhone className="contact_icon" />
                    <strong>Phone:</strong> <a href="tel:+46762467194" className="contact_link">+46 76 246 71 94</a>
                  </p>
                  <p className="contact_item">
                    <FaGlobe className="contact_icon" />
                    <strong>Website:</strong> <a href="http://falcop.com/" target="_blank" rel="noopener noreferrer" className="contact_link">falcop.com</a>
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 col-6">
              <div className="footer_links_section">
                <h4 className="footer_section_title">Quick Links</h4>
                <ul className="footer_links_list">
                  <li><a href="#About" className="footer_link">About</a></li>
                  <li><a href="#NFT" className="footer_link">Collection</a></li>
                  <li><a href="#HowToMint" className="footer_link">How to Mint</a></li>
                  <li><a href="#FAQ" className="footer_link">FAQ</a></li>
                </ul>
              </div>
            </div>

            {/* Collection Info */}
            <div className="col-lg-3 col-md-6 col-6">
              <div className="footer_links_section">
                <h4 className="footer_section_title">Collection</h4>
                <ul className="footer_links_list">
                  <li><a href="#" className="footer_link">WING P #1</a></li>
                  <li><a href="#" className="footer_link">WING P #2</a></li>
                  <li><a href="#" className="footer_link">WING P #3</a></li>
                  <li><a href="#" className="footer_link">View All</a></li>
                </ul>
              </div>
            </div>

            {/* Newsletter & CTA */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="footer_newsletter">
                <h4 className="footer_section_title">Stay Updated</h4>
                <p className="newsletter_description">
                  Get the latest updates on new drops, exclusive releases, and community events.
                </p>
                <div className="newsletter_form">
                  <input 
                    type="email" 
                    placeholder="Enter your email" 
                    className="newsletter_input"
                  />
                  <button className="newsletter_btn">Subscribe</button>
                </div>
                <a href="https://discord.gg/T5XsyYjR" target="_blank" rel="noopener noreferrer" className='discord_btn' style={{textDecoration: 'none', display: 'inline-flex', alignItems: 'center'}}>
                  <FaDiscord size={20} className="me-2" />
                  Join our Discord
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer_bottom">
          <div className="row align-items-center">
            <div className="col-md-6 col-12">
              <p className="copyright_text">
                © 2024 FalcoP. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 col-12">
              <div className="footer_legal_links">
                <a href="#" className="legal_link">Terms & Conditions</a>
                <a href="#" className="legal_link">Privacy Policy</a>
                <a href="#" className="legal_link">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}